import { inject, Injectable, TemplateRef } from '@angular/core';
import { App } from '@df/core/app';
import { injectTimeoutService } from '@df/ng/timeout.service';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { ModalService } from '@df/ui/modal/modal.service';

@Injectable({
    providedIn: 'root'
})
export class ProductConfigurableOptionsService {
    protected modalRef?: ModalRef<unknown>;
    protected isOpened = false;

    protected modalService = inject(ModalService);
    protected app = inject(App);
    protected timeoutService = injectTimeoutService();

    get canOpen(): boolean {
        return !this.modalRef;
    }

    openTray(
        template: TemplateRef<unknown>,
        onOpen?: () => void,
        onClose?: () => void,
        config: ModalConfig = {
            width: '100%',
            height: '100%',
            hasBackdrop: true,
            disableClose: true,
            scrollStrategy: this.app.client.isS && !this.app.client.isCms && this.app.isPlatformBrowser ? 'noop' : 'block',
            panelClass: 'panel-product-configurable-options',
            modalClass: 'modal-container-overflow-hidden',
            backdropClass: 'no-off-click-cdk-overlay-dark-backdrop'
        }
    ): void {
        if (!this.canOpen) {
            return;
        }

        this.modalRef = this.modalService.openBottom(template, {
            ...config,
            onOpen: () => {
                this.timeoutService.setTimeout(() => {
                    this.isOpened = true;
                }, 100);
                onOpen?.();
            },
            onClose: () => {
                this.isOpened = false;
                onClose?.();
            },
            onBackdropClick: () => {
                if (this.isOpened) {
                    this.closeTray();
                }
            }
        });
    }

    closeTray(): void {
        this.modalRef?.close();
        this.modalRef = undefined;
    }
}
